module.exports = __webpack_public_path__ + "static/media/icons-yc-zoom-in-hover.251ba83f.svg";